module.exports = __webpack_public_path__ + "img/year.be5030ca.webp";